import { useQuery } from "@tanstack/react-query";
import { AvailabilityControllerApi, AvailabilitySetting } from "../services";
import {
  asPaginatedContent,
  getConfigObject,
  useBaseContent,
} from "../utils/utils";

interface UseUsersListProps {
  providerUuid?: string;
  providerGroupId?: string;
}

/**
 *
 * @author Shrinivas Mandhare
 */

export function useGetAvailabilitySettings({
  providerUuid,
  providerGroupId,
}: UseUsersListProps): useBaseContent<AvailabilitySetting> {
  return useQuery({
    queryKey: ["provider-availability-settings", providerGroupId, providerUuid],
    enabled: !!providerUuid,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      return new AvailabilityControllerApi(getConfigObject())
        .getProviderAvailabilitySetting(
          providerUuid!,
          providerGroupId //xTENANTID
        )
        .then((it) => asPaginatedContent<AvailabilitySetting>(it?.data));
    },
  });
}
